<div class="d-flex justify-content-center p-5">
  <div class="spinner-border text-danger" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
